import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import "./SBSHelpProvider.css";

export const SBSHelpContext = createContext(null);

const HELP_MODE_STORAGE_KEY = "sbsHelpMode";

function readStoredHelpMode() {
  if (typeof window === "undefined") return false;

  try {
    return window.localStorage.getItem(HELP_MODE_STORAGE_KEY) === "true";
  } catch (err) {
    console.warn("Unable to load SBS help mode.", err);
    return false;
  }
}

export function SBSHelpProvider({ children }) {
  const [helpMode, setHelpMode] = useState(readStoredHelpMode);

  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      window.localStorage.setItem(HELP_MODE_STORAGE_KEY, String(helpMode));
    } catch (err) {
      console.warn("Unable to save SBS help mode.", err);
    }
  }, [helpMode]);

  const toggleHelpMode = useCallback(() => {
    setHelpMode((currentHelpMode) => !currentHelpMode);
  }, []);

  const value = useMemo(
    () => ({
      helpMode,
      toggleHelpMode,
      setHelpMode,
    }),
    [helpMode, toggleHelpMode]
  );

  return (
    <SBSHelpContext.Provider value={value}>
      {children}
    </SBSHelpContext.Provider>
  );
}

export default SBSHelpProvider;
